/* Aqui van los paises a los cuales se puede registrar un usuario */
/*  Argentina, mexico, colombia, chile  */
export const Countries: Country[] = [
    { name: 'Argentina', code: 'AR', phoneCode: '+54', flag: '🇦🇷', provinces: [
        'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
    ] },
     { name: 'Chile', code: 'CL', phoneCode: '+56', flag: '🇨🇱' },
     { name: 'Colombia', code: 'CO', phoneCode: '+57', flag: '🇨🇴' },
    { name: 'México', code: 'MX', phoneCode: '+52', flag: '🇲🇽' }
];

export interface Country{
    name: string;
    code: string;
    phoneCode?: string;
    flag?: string;
    provinces?: string[];
}